<template>
  <div class="footer">
    <div>
      <ul>
        <li @click="explanatory('PrivacyPolicy')">隐私政策</li>
        <li class="line-space"></li>
        <li @click="explanatory('UserStatement')">用户声明</li>
        <li class="line-space"></li>
        <li @click="explanatory('ContactUs')">联系我们</li>
      </ul>
    </div>
    <div class="copy-right">
      Copyright © {{new Date().getFullYear()}} 上海高绩数据科技有限公司 版权所有 保留一切权利
      <div style="margin-top:8px">沪ICP备20015007号-1</div>
    </div>
  </div>
</template>

<script>
import { setExplanatoryType } from '@/utils/auth.js'
export default {
  name: "dxj-footer",
  data() {
    return {};
  },
  methods: {
    explanatory(type) {
      setExplanatoryType(type);
      let href = location.href;
      let hash = location.hash;
      let openUrl = href.replace(hash, `#/explanatory`);
      window.open(openUrl);
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #a4a4ad;
  justify-content: center;
  .copy-right {
    margin-top: 14px;
    height: 16px;
    line-height: 16px;
    span{
      margin-left: 12px;
    }
  }
  ul {
    display: flex;
    flex-direction: initial;
    align-items: center;
    height: 14px;
    line-height: 14px;
    .line-space {
      width: 1px;
      height: 1rem;
      background-color: #c1c1c1;
      margin: 0 8px;
    }
    li:not(.line-space) {
      &:hover {
        cursor: pointer;
        color: #1c8cf5;
      }
    }
  }
}
</style>
